<template>
  <PblmWarranty/>
</template>
<script>
import PblmWarranty from 'place/warranty/pblmWarranty.vue'
export default {
    components:{
      PblmWarranty
    }
}
</script>